/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Form_LabelInputs */

const en_segment_event_group_form_label = /** @type {(inputs: Segment_Event_Group_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segment Event Group Form`)
};

const fr_segment_event_group_form_label = /** @type {(inputs: Segment_Event_Group_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulaire de segmentation du groupe d'evenements`)
};

const de_segment_event_group_form_label = /** @type {(inputs: Segment_Event_Group_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formular für die Segment-Ereignisgruppe`)
};

const it_segment_event_group_form_label = /** @type {(inputs: Segment_Event_Group_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modulo di gruppo di eventi del segmento`)
};

const ru_segment_event_group_form_label = /** @type {(inputs: Segment_Event_Group_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Форма группы событий сегмента`)
};

const es_segment_event_group_form_label = /** @type {(inputs: Segment_Event_Group_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulario de grupo de eventos de segmento`)
};

const zh_cn2_segment_event_group_form_label = /** @type {(inputs: Segment_Event_Group_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分段事件组表单`)
};

const ja_segment_event_group_form_label = /** @type {(inputs: Segment_Event_Group_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セグメントイベントグループフォーム`)
};

const hi_segment_event_group_form_label = /** @type {(inputs: Segment_Event_Group_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खंड घटना समूह प्रपत्र`)
};

const pt_pt2_segment_event_group_form_label = /** @type {(inputs: Segment_Event_Group_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formulário de Grupo de Eventos de Segmento`)
};

/**
* | output |
* | --- |
* | "Segment Event Group Form" |
*
* @param {Segment_Event_Group_Form_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_form_label = /** @type {((inputs?: Segment_Event_Group_Form_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Form_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_segment_event_group_form_label(inputs)
	if (locale === "de") return de_segment_event_group_form_label(inputs)
	if (locale === "it") return it_segment_event_group_form_label(inputs)
	if (locale === "ru") return ru_segment_event_group_form_label(inputs)
	if (locale === "es") return es_segment_event_group_form_label(inputs)
	if (locale === "zh-CN") return zh_cn2_segment_event_group_form_label(inputs)
	if (locale === "ja") return ja_segment_event_group_form_label(inputs)
	if (locale === "hi") return hi_segment_event_group_form_label(inputs)
	if (locale === "pt-PT") return pt_pt2_segment_event_group_form_label(inputs)
	return en_segment_event_group_form_label(inputs)
});